module.exports = __webpack_public_path__ + "static/media/target.7118115d.png";